import { KoncentroBaseModel } from './koncentro-base.model';

export class User {
  public id: number;
  public role_id: number;
  public login: string;
  public email: string;
  public role_desc?: string;
  public name: string;
  public surname: string;
  public pwd_expiry: string;
  public flg_ext?: number;
  public send_email?: number;
}

export class EditUser extends User {
  public password: string;
  public confirmPassword: string;
  public pwd_expiry_date: number;
}


export class UserComplex {
  public user: User;
  public companies: number[];
  public date_start: string;
  public date_end: string;
}


export class UserCompany {
  public id: number;
  public name: string;
  public company_id: number;
  public user_id: number;
  public date_start: Date;
  public date_end: Date;
}

export class UserApplication {
  public id: number;
  public user_id: number;
  public company_name: string;
  public company_id: number;
  public application_name: string;
  public application_description: string;
  public application_id: number;
  public ms_base_url?: string;
  public app_icon?: string;
  public date_start: Date;
  public date_end: Date;
}

export class UserRoleModel extends KoncentroBaseModel {
  id: number;
  user_id: number;
  role_id: number;
}



// WEBPACK FOOTER //
// ./src/app/models/user.model.ts